import { render, staticRenderFns } from "./CategoryWidget.vue?vue&type=template&id=76688d92&scoped=true"
import script from "./CategoryWidget.vue?vue&type=script&lang=js"
export * from "./CategoryWidget.vue?vue&type=script&lang=js"
import style0 from "./CategoryWidget.vue?vue&type=style&index=0&id=76688d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76688d92",
  null
  
)

export default component.exports